import storageKey from 'helpers/storageKey';

// eslint-disable-next-line import/prefer-default-export
export const dismissedWizardKey = storageKey('ENTANDO_WELCOME_WIZARD_DISMISSED');
